import { RouteAlias } from '../router/alias';

export const AGENT_SSO_START_URL = 'https://dl.aiopentool.com/sso/start';

const blockedRedirectPrefixes = [
  '/admin',
  RouteAlias.login,
  RouteAlias.signUp,
  RouteAlias.accountRecovery,
  RouteAlias.changeEmail,
  RouteAlias.passwordReset,
  RouteAlias.accountActivation,
  RouteAlias.activationSuccess,
  RouteAlias.activationFailed,
  RouteAlias.confirmNewEmail,
  RouteAlias.confirmEmail,
  RouteAlias.authLanding,
  RouteAlias.suspended,
];

const getUrlBase = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://answer.local';
};

export const normalizeLoginRedirectPath = (redirect?: string | null) => {
  const value = (redirect || '').trim();
  if (value === AGENT_SSO_START_URL) {
    return AGENT_SSO_START_URL;
  }
  if (!value || !value.startsWith('/') || value.startsWith('//')) {
    return RouteAlias.home;
  }

  let path = value;
  try {
    const url = new URL(value, getUrlBase());
    if (url.origin !== getUrlBase()) {
      return RouteAlias.home;
    }
    path = `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return RouteAlias.home;
  }

  const pathname = path.split(/[?#]/, 1)[0].toLowerCase();
  const blocked = blockedRedirectPrefixes.some((prefix) => {
    const prefixPath = prefix.split(/[?#]/, 1)[0].toLowerCase();
    return pathname === prefixPath || pathname.startsWith(`${prefixPath}/`);
  });

  if (blocked) {
    return RouteAlias.home;
  }

  return path;
};
